<template>
  <div
    class="flex items-start gap-4 justify-between bg-white border border-gray-200 rounded-xl p-2 shrink-0"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        v-if="isImage"
        class="w-10 h-10 border border-gray-200 rounded-lg overflow-hidden shrink-0"
      >
        <img
          class="w-full h-full object-cover"
          :src="imageSrc"
          @error="$emit('image-error')"
        />
      </div>
      <div
        v-else
        class="w-10 h-10 flex items-center justify-center rounded-lg shrink-0 relative"
      >
        <img
          :src="documentIcon"
          alt="document-icon"
          class="absolute top-0 ltr:right-0 rtl:left-0 z-1"
        />
        <span class="file-extensition" :class="iconColorClass">
          {{ extension }}
        </span>
      </div>
      <div class="flex flex-col gap-1 min-w-0 flex-1">
        <span class="text-sm leading-5 text-[#323431] truncate">
          {{ fileName }}
        </span>
        <span v-if="fileSize" class="text-xs leading-[18px] text-[#5c5c5c]">
          {{ fileSize }}
        </span>
      </div>
    </div>
    <div class="shrink-0">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
import DocumentIcon from 'dashboard/assets/images/document.svg';

export default {
  props: {
    isImage: { type: Boolean, default: false },
    imageSrc: { type: String, default: '' },
    fileName: { type: String, default: '' },
    fileSize: { type: String, default: '' },
    extension: { type: String, default: '' },
    iconColorClass: { type: String, default: 'text-gray-400' },
  },
  emits: ['image-error'],
  data() {
    return {
      documentIcon: DocumentIcon,
    };
  },
};
</script>

<style>
.file-extensition {
  font-size: 10px;
  padding: 4px;
  border: 1px solid #d4d4d8;
  line-height: 7px;
  border-radius: 3px;
  font-weight: 600;
  background: white;
  position: absolute;
  bottom: 5px;
  left: 2px;
  user-select: none;
}
</style>
